import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  UncontrolledAlert,
} from "reactstrap";


// Pages Components
import WelcomeComp from "./WelcomeComp";
import NotificationDashboard from "./NotificationDashboard";
import { postSubmitForm } from "../../helpers/forms_helper";
//i18n
import { withNamespaces } from "react-i18next";
import DashboardForESM from "../../components/Dashboards/DashboardForESM";
import DashboardForStoreManager from "../../components/Dashboards/DashboardForStoreManager";
import DashboardForCSM from "../../components/Dashboards/DashboardForCSM";
import DashboardForCKM from "../../components/Dashboards/DashboardForCKM";
import DashboardForBS from "../../components/Dashboards/DashboardForBS";
import DashboardForOwner from "../../components/Dashboards/DashboardForOwner";
const Dashboard = (props) => {


  useEffect(() => {
    loadNotifications();
    loadItemOrderCounts();
  }, []);
  
  const [notifications, setNotifications] = useState([]);
  const loadNotifications = async () => {
    let url = process.env.REACT_APP_BASEURL + "notifications/get_last_ten";
    const response = await postSubmitForm(url, "");
    if (response && response.status === 1) {
      setNotifications(response.data);
    }
  };


  const [itemOrderCounts, setAllItemOrderCounts] = useState();
  const loadItemOrderCounts = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/order_counts";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllItemOrderCounts(response.data);
    }
  };

  const role = localStorage.getItem("role");
  const [productClosurePending, setProductClosurePending] = useState();
  const [itemClosurePending, setItemClosurePending] = useState();

  const checkClosures = async () => {
    let url1 = process.env.REACT_APP_BASEURL + "branchproductclosures/check";
    let response1 = await postSubmitForm(url1, "");
    if (response1.status === 1) {
      setProductClosurePending(response1.data);
    }

    let url2 = process.env.REACT_APP_BASEURL + "branchitemclosures/check";
    let response2 = await postSubmitForm(url2, "");
    if (response2.status === 1) {
      setItemClosurePending(response2.data);
    }
  };

  useEffect(() => {
    if (role === "Branch Supervisor" || role === "Central Kitchen Manager") {
      checkClosures();
    }
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
   
          {productClosurePending && productClosurePending.pending && (
            <Row>
              <Col lg={12}>
                <UncontrolledAlert
                  color="warning"
                  className="alert-dismissible fade show"
                  role="alert"
                >
                  <i className="mdi mdi-alert-outline me-2"></i>{" "}
                  {productClosurePending.message}
                </UncontrolledAlert>
              </Col>
            </Row>
          )}
          {itemClosurePending && itemClosurePending.pending && (
            <Row>
              <Col lg={12}>
                <UncontrolledAlert
                  color="warning"
                  className="alert-dismissible fade show"
                  role="alert"
                >
                  <i className="mdi mdi-alert-outline me-2"></i>{" "}
                  {itemClosurePending.message}
                </UncontrolledAlert>
              </Col>
            </Row>
          )}

          <CardTitle>{props.t("DASHBOARD")}</CardTitle>

          <Row>
            <Col xl="8">
              <Row>
                {(role !== "Sub Store Manager" && role !== "Main Store Manager" && role !== "Branch Supervisor"
                && role !== "Central Kitchen Manager" && role !=="Central Store Manager" && role !== "Equipment Store Manager" 
                && role !== "Storekeeper" && role !== "Owner") && (
                  
                  <Col xl="4" md="6">
                  <WelcomeComp />
                </Col>
                )}
             

                <Col xl="12">
                  {role === "Central Kitchen Manager" && (
                   <DashboardForCKM />
                  )}

                  {(role === "Central Store Manager" || role === "Storekeeper" )&& (
                    <DashboardForCSM />
                  )}


                  {(role === "Main Store Manager" ||role === "Sub Store Manager"  ) && (
                    <DashboardForStoreManager/>
                  )}

                </Col>
                
              </Row>
              {role === "Branch Supervisor" && ( <DashboardForBS /> )}

              {role === "Equipment Store Manager" && ( <DashboardForESM /> )}

              {role === "Owner" && (  <DashboardForOwner /> )}

            </Col>

            <Col xl="4">
              <NotificationDashboard
                data={notifications}
                setNotificationsRead={() => { }}
                viewAll={true}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withNamespaces()(Dashboard);
